<template>
  <div id="general-conditions">
    <div class="content">
      <header>
        <div class="row-inner">
          <a href="/">
            <img class="logo logo-desktop" src="./../assets/img/logos/logo-driessen-desktop.svg" alt="Driessen Logo">
            <img class="logo logo-mobile" src="./../assets/img/logos/logo-driessen-mobile.svg" alt="Driessen Logo">
          </a>
        </div>
      </header>
      <main>
        <h1>Algemene voorwaarden</h1>
        <div class="row-inner content-style content-style--white">
          <h2>Privacy beleid www.testjewerkgeluk.nl</h2>
          <p>Driessen neemt de privacy van haar bezoekers zeer serieus en zal persoonlijke gegevens over u
            op een veilige
            manier verwerken en gebruiken. Hierbij houdt Driessen zich aan de wet- en regelgeving op het gebied van de
            bescherming van persoonsgegevens, zoals de Algemene verordening gegevensbescherming (AVG).</p>
          <h3>Gegevens van websitebezoekers</h3>
          <p>In het algemeen kunt u onze website bezoeken zonder persoonsgegevens aan ons te verstrekken. Wel verzamelt Driessen, net als veel andere websites, bepaalde niet-identificeerbare automatische informatie, zoals het type browser waarvan u gebruik maakt, de datum en tijd van toegang tot de website, de regio van waaruit u onze website bezoekt en de pagina's en onderdelen van
            de website die u bezoekt en informatie u bekijkt.</p>
          <p>De verzamelde gegevens worden gebruikt om de inhoud van de website optimaal af te stemmen op de wensen en de behoeftes van de bezoekers van onze website. Driessen kan deze informatie eventueel doorgeven aan derden. Deze gegevens kunnen worden bewaard voor toekomstig gebruik. Hiervoor maakt onze website gebruik van cookies. Zie voor meer informatie ons <a href="/cookies">cookie
            statement</a> of <a class="diffuse-cookie-settings" href="#">wijzig hier uw cookie instellingen</a>.</p>
          <h3>Doeleinden gegevensverzameling Werkgeluk test</h3>
          <p>Wanneer u deelneemt aan de Werkgeluk test, worden de verzamelde gegevens (uw antwoorden) voor
            de volgende
            doeleinden gebruiken:</p>
          <ol class="visible">
            <li>om u op basis van uw antwoorden het resultaat (uitslag) te tonen van de Werkgeluk test;</li>
            <li>de resultaten (uitslagen) van deelnemers aan de Werkgeluk test worden geanonimiseerd samengevoegd en
              dienen als benchmark, o.a. voor een onderzoek met publicatie(s) naar werkgeluk in Nederland;
            </li>
            <li>om geldende wet- en regelgeving na te kunnen komen (bijv. uw toestemming om u een e-mail toe te
              sturen);
            </li>
            <li>eventueel kunt u ons toestemming geven om u te informeren over onze dienstverlening en overige
              activiteiten (bijvoorbeeld via e-mail) en om u aanbiedingen te kunnen doen.
            </li>
          </ol>
          <h3>Welke gegevens</h3>
          <p>De Werkgeluk test verwerkt onder meer de volgende gegevens:</p>
          <ul class="visible">
            <li>provincie</li>
            <li>leeftijdscategorie</li>
            <li>opleidingsniveau</li>
            <li>functieniveau</li>
            <li>sector</li>
            <li>geslacht (niet verplicht)</li>
            <li>naam (niet verplicht)</li>
            <li>e-mailadres (niet verplicht)</li>
            <li>de antwoorden op gestelde vragen</li>
          </ul>
          <h3>Gebruik door derden</h3>
          <p>Driessen verstrekt persoonsgegevens die zijn verzameld via de Werkgeluk test niet aan
            derden.</p>
          <h3>Bijzondere persoonsgegevens</h3>
          <p>Driessen verwerkt uitsluitend bijzondere persoonsgegevens, voor zover u hier expliciet
            toestemming voor
            geeft, dan wel deze verwerking in overeenstemming is met de geldende wet- en/of regelgeving. Tot de
            bijzondere persoonsgegevens die u aan Driessen verstrekt hebben alleen personen toegang die over deze
            gegevens dienen te beschikken voor de (uitvoering van) hun werkzaamheden en/of ter voldoening aan de
            geldende wet- en regelgeving.</p>
          <h3>Beveiliging</h3>
          <p>Driessen heeft passende technische en organisatorische maatregelen genomen om uw
            persoonsgegevens te
            beveiligen tegen verlies of enige vorm van onrechtmatige verwerking. Uw persoonsgegevens kunnen worden
            verwerkt buiten Nederland. Driessen heeft de nodige maatregelen genomen om te verzekeren dat alle
            doorgegeven persoonsgegevens adequaat worden beschermd.</p>
          <p>Ondanks de door Driessen genomen veiligheidsmaatregelen, kan het voorkomen dat anderen er
            toch in slagen
            deze maatregelen te omzeilen en/of uw persoonsgegevens voor oneigenlijke doeleinden te gebruiken. Driessen
            kan hiervoor nooit op enigerlei wijze aansprakelijk worden gesteld. Zie ook onze <a
              href="https://www.driessen.nl/content/digitale-klokkenluidersregeling?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank"
              rel="noopener noreferrer">Digitale
              klokkenluidersregeling</a> (responsible disclosure procedure) op driessen.nl.</p>
          <h3>Bewaren van uw gegevens</h3>
          <p>Driessen bewaart uw persoonsgegevens niet langer dan noodzakelijk voor de verwerkelijking van
            de doeleinden
            waarvoor zij zijn verzameld en worden verwerkt. Wij hanteren een bewaartermijn van 2 jaar.</p>
          <h3>Inzage in, wijziging en verwijdering van uw gegevens</h3>
          <p>Als u inzage wenst in uw totale persoonsgegevensverwerking en/of gegevens wilt wijzigen of
            verwijderen die u
            zelf niet kunt aanpassen, dan kunt u contact opnemen met <a href="mailto:communicatie@driessengroep.nl">communicatie@driessengroep.nl</a>
            of uw contactpersoon
            bij Driessen.</p>
          <h3>Verwijzingen en links naar andere websites</h3>
          <p>Op de website treft u een aantal links aan naar andere websites. Hoewel deze websites met
            zorg zijn
            geselecteerd, kan Driessen geen verantwoordelijkheid dragen met betrekking tot het gebruik van uw gegevens
            door die organisaties. Op deze websites valt u onder de privacyregels van die betreffende website. Lees
            daarom, indien aanwezig, het privacy statement van de website die u bezoekt.</p>
          <h3>Wijzigingen</h3>
          <p>Driessen behoudt zich het recht voor om wijzigingen aan te brengen in dit privacy statement.
            Check daarom
            regelmatig het privacy statement voor een update van het privacy beleid.</p>
          <h3>Vragen, opmerkingen of klachten</h3>
          <p>Indien u vragen, opmerkingen of klachten heeft met betrekking tot dit privacy statement of de
            wijze waarop
            Driessen uw gegevens registreert en verwerkt, dan kunt u contact met ons opnemen per e-mail via
            <a href="mailto:info@driessen.nl">info@driessen.nl</a> of door een brief te sturen naar Driessen, t.a.v.
            Juridische Zaken, Postbus 748, 5700 AS
            Helmond.</p>
        </div>
      </main>
      <footer>
        <div class="row-inner">
          <div class="footer-content">
            <div class="logo-footer">
              <img class="logo-drop" src="./../assets/img/logos/logo-driessen-drop.svg" alt="Driessen Logo">
            </div>
            <div class="social-links follow">
              <span class="label">Volg ons</span>
              <ul>
                <li class="facebook">
                  <a href="https://www.facebook.com/driessen.nl" target="_blank" rel="noopener noreferrer">Facebook</a>
                </li>
                <li class="linkedin">
                  <a href="https://www.linkedin.com/company/driessen-nl" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                </li>
                <li class="twitter">
                  <a href="https://twitter.com/Driessen_nl"
                     target="_blank" rel="noopener noreferrer">Twitter</a>
                </li>
                <li class="youtube">
                  <a href="https://www.youtube.com/user/DriessenHRM"
                     target="_blank" rel="noopener noreferrer">Whatsapp</a>
                </li>
                <li class="instagram">
                  <a href="https://www.instagram.com/driessen.nl"
                     target="_blank" rel="noopener noreferrer">Instagram</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'GeneralConditions',
    data() {
      return {}
    },
    methods: {
      toggleBodyClass(addRemoveClass, className) {
        const el = document.body;

        if (addRemoveClass === 'addClass') {
          el.classList.add(className);
        } else {
          el.classList.remove(className);
        }
      },
    },
    mounted() {
      this.toggleBodyClass('addClass', 'general-conditions');
    },
    destroyed() {
      this.toggleBodyClass('removeClass', 'general-conditions');
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/GeneralConditions.vue